import type { VariantProps } from 'class-variance-authority';
import { getAbbreviation } from '@/utils/getAbbreviation';
import { cn } from '@/utils/сn';
import { avatarInitialsStyles, avatarStyles } from './styles';

interface AvatarProps extends VariantProps<typeof avatarStyles> {
  name: string;
  imageUrl?: string;
  className?: string;
}

export const Avatar = ({ name, imageUrl, size = 'small', className }: AvatarProps) => (
  <div className={cn(avatarStyles({ size }), className)}>
    <div
      className={avatarInitialsStyles({ size })}
      style={imageUrl ? { backgroundImage: `url(${imageUrl})` } : undefined}
    >
      {imageUrl ? null : getAbbreviation(name)}
    </div>
    <span className="absolute inset-0 rounded-full border-[0.5px] border-black opacity-8" aria-hidden />
  </div>
);
